export default class OffCanvasMenu {

    constructor() {

        this.bindUIActions();

    }

    bindUIActions() {

        let $navMobile = $('i[data-nav-mobile]');
        let $navMobileArray = $navMobile.toArray();

        $navMobileArray.forEach((navItem) => {

            let navItemVal = navItem.getAttribute('data-nav-mobile');

            navItem.addEventListener('click', function () {
                let $navChildren = $('ul[data-nav-child-mobile]');
                let $navChildrenArray = $navChildren.toArray();

                navItem.classList.toggle('active');

                $navChildrenArray.forEach((child) => {
                    if (child.getAttribute('data-nav-child-mobile') === navItemVal) {
                        child.classList.toggle('max-h-0');
                        child.classList.toggle('overflow-hidden');
                    }
                });

            });

        });

    }

};

new OffCanvasMenu();